<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

    <div class="root-body-inner">
        <!--<div class="pml-header">
            <div class="pml-header-title">{{groupName}}</div>
        </div>-->
        <!-- Table -->
        <p-table [columns]="cols"
                 [value]="stores"
                 [lazy]="true"
                 (onLazyLoad)="handleLazyLoad($event)"
                 [paginator]="true"
                 [(first)]="first"
                 [rows]="rowsPerPage"
                 [rowsPerPageOptions]="rowsPerPageOptions"
                 [totalRecords]="totalRecords"
                 [resizableColumns]="true"
                 [columnResizeMode]="'expand'"
                 [autoLayout]="true"
                 [styleClass]="'p-datatable-striped'"
                 [scrollable]="true"
                 [scrollHeight]="'flex'">
            <ng-template pTemplate="caption">
                <div class="pml-header">
                    <div class="pml-header-title">{{groupName}}</div>
                </div>
                <div class="pmlgs-title">Stores included to the group</div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of cols"
                        [pSortableColumn]="col.field"
                        [pSortableColumnDisabled]="col.disableSort"
                        pResizableColumn
                        [style.width]="col.width">
                        {{col.header}}
                        <p-sortIcon *ngIf="sortField===col.field" [field]="col.field"></p-sortIcon>
                    </th>
                    <th>Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-store>
                <tr>
                    <td *ngFor="let col of cols"
                        class="ui-resizable-column"
                        [style.width]="col.width">
                        {{store[col.field]}}
                    </td>
                    <td>
                        <span class="action-icon-svg" (click)="onEditStoreClick(store)">
                            <img src="{{adminUrl}}XpressApp/assets/images/grid/icon_edit.svg" />
                        </span>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                <div *ngIf="stores.length > 0" style="padding-left: 10px">
                    Displaying {{first + 1}} - {{first + stores.length}} of {{totalRecords}}
                </div>
            </ng-template>
        </p-table>
    </div>
</div>

<p-toast position="top-right"></p-toast>

<spinner *ngIf="isSpinnerVisible" style="position: fixed; top: 40vh; left: 60vw"></spinner>
